import React from "react";
import "./Withdrawal.css";

export default function Withdrawal() {
  return (
    <div className="withdrawal-container">
      <span className="withdrawal-text">탈퇴하기</span>
    </div>
  );
}
